import React from "react";
import { TailSpin } from "react-loader-spinner";
import "./Loading.scss";
export default function Loading({ visible }) {
  return (
    <div className="loading_bg">
      <TailSpin
        height="70"
        width="60"
        color="black"
        ariaLabel="tail-spin-loading"
        radius="1"
        wrapperStyle={{}}
        wrapperClass=""
        visible={visible}
      />
      <div className="loading_msg">잠시만 기다려주세요</div>
    </div>
  );
}
